import { useMemo } from 'react';

import {
   Bean,
   getCustomFormattingContext,
   MoneyPatternType,
   priceRangeFormatter,
   ValidationRules,
} from '@dreryk/react-common';
import {
   InteractiveTable,
   InteractiveTableCellProps,
   Text,
   useInteractiveTableContext,
} from '@dreryk/react-components';

import {
   ReceptionServicePractitionerIndividualPriceRange,
   ReceptionServicePractitionerValue,
} from '../../receptionServicePractitioner.types';
import { usingDefaultConfigurationVisitor } from '../ReceptionServicePractitionersInteractiveTable.utils';

type ReceptionServicePractitionerIndividualPriceRangeCellProps = InteractiveTableCellProps<ReceptionServicePractitionerIndividualPriceRange | null> & {
   readonly defaultValue: ReceptionServicePractitionerIndividualPriceRange | null;
};

export const ReceptionServicePractitionerIndividualPriceRangeCell = (
   props: ReceptionServicePractitionerIndividualPriceRangeCellProps
): JSX.Element => {
   const { getCellValue } = useInteractiveTableContext<ReceptionServicePractitionerValue>();
   const usingDefaultConfiguration = getCellValue('usingDefaultConfiguration', props.index);

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: !usingDefaultConfiguration,
      };
   }, [usingDefaultConfiguration]);

   return usingDefaultConfigurationVisitor(usingDefaultConfiguration)({
      withDefaultConfiguration: () => (
         <InteractiveTable.CustomCell
            defaultValue={props.defaultValue}
            index={props.index}
            name={props.name}
            testId={props.testId}
         >
            {(value) =>
               value && value.min <= value.max ? (
                  <Text testId={'priceRangeCell'}>
                     {priceRangeFormatter(
                        {
                           min: value.min,
                           max: value.max,
                        },
                        getCustomFormattingContext({ options: { currency: 'PLN', stripDecimalZeroes: true } })
                     )}
                  </Text>
               ) : (
                  <></>
               )
            }
         </InteractiveTable.CustomCell>
      ),
      withIndividualConfiguration: () => (
         <InteractiveTable.MoneyRangeInputCell
            testId={props.testId}
            name={props.name}
            index={props.index}
            validationRules={validationRules}
            defaultValue={props.defaultValue}
            minSize={5}
            maxSize={9}
            min={1}
            max={999999.99}
            pattern={MoneyPatternType.POSITIVE}
            disabled={usingDefaultConfiguration}
         />
      ),
   });
};
